import * as React from "react";
import ModalAction, { ModalActionProps } from "./ModalAction";

export class ModalWarning extends React.Component<ModalActionProps> {
  render() {
    return (
      <ModalAction
        title={this.props.title}
        cancelButtonLabel={this.props.cancelButtonLabel}
        actionButtonLabel={this.props.actionButtonLabel}
        cancel={this.props.cancel}
        action={this.props.action}
        dialogClass={"v-flex warning-dialog"}
        actionButtonClass={"warning"}
        iconElement={"ic_warning"}
        hideCloseIcon={true}
      >
        {this.props.children}
      </ModalAction>
    );
  }
}
